import { config as commonConfig } from '../../../common/global/config';
import { BenefitConfig } from '../../../common/types';

export const config: BenefitConfig = {
  ...commonConfig,
  benefitApiUrl: process.env.REACT_APP_BENEFIT_API_URL ?? '',
  legacyFoUrl: process.env.REACT_APP_LEGACY_FO_URL ?? '',
  filesUrl: process.env.REACT_APP_FILES_URL ?? '',
  blueCardContractTemplatePath:
    process.env.REACT_APP_TOPUP_BLUE_CARD_CONTRACT_TEMPLATE_PATH ?? '',
  journeySheetTemplatePath:
    process.env.REACT_APP_TOPUP_BLUE_CARD_JOURNEY_SHEET_TEMPLATE_PATH ?? '',
  journeySheetCompletedTemplatePath:
    process.env
      .REACT_APP_TOPUP_BLUE_CARD_JOURNEY_SHEET_COMPLETED_TEMPLATE_PATH ?? '',
  homePageNumberOfLatestBrands: Number.parseInt(
    process.env.REACT_APP_HOMEPAGE_NUMBER_OF_LATEST_BRANDS ?? '6',
  ),
  homePageNumberOfCategories: Number.parseInt(
    process.env.REACT_APP_HOMEPAGE_NUMBER_OF_CATEGORIES ?? '8',
  ),
  categoryPageMostPopularBrandsNo: Number.parseInt(
    process.env.REACT_APP_CATEGORY_PAGE_MOST_POPULAR_BRANDS_NO ?? '6',
  ),
  zeroProcentTaxtClassId: Number.parseInt(
    process.env.ZERO_PROCENT_TAX_CLASS_ID ?? '0',
  ),
  carouselProductsLength: Number.parseInt(
    process.env.REACT_APP_CAROUSEL_PRODUCTS_LENGTH ?? '12',
  ),
  druidWebchat: {
    botId: process.env.REACT_APP_DRUID_WEBCHAT_BOT_ID ?? '',
    baseUrl: process.env.REACT_APP_DRUID_WEBCHAT_BASE_URL ?? '',
  },
  showVirtualCards: process.env.REACT_APP_SHOW_VIRTUAL_CARDS === 'true',
  defaultCompanyLogo: process.env.REACT_APP_COMPANY_LOGO_NO_IMAGE_PATH ?? '',
  onetrustCookiesScriptSrc:
    process.env.REACT_APP_ONETRUST_COOKIES_SCRIPT_SRC ?? '',
  onetrustCookiesDataDomainId:
    process.env.REACT_APP_ONETRUST_COOKIES_DATA_DOMAIN_ID ?? '',
};
